// JavaScript Document
//components/configuration/standard/tabs/Messages.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
//Custom Component Imports
import Canvas from '../../display/canvas/Canvas';
import Display from '../../display/Display';
import displayVariant from '../displayVariant';
import Selector from '../../display/message/Selector';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
	displayList : {
		marginTop:38
	},
}));

export default function OverviewStandard(props) {
  	const classes = useStyles();
  	const {config, sign, handleSend, loadedToken, onChange} = props;
	const [selected, setSelected] = React.useState(0);
	const [displays, setDisplays] = React.useState([]);
	const [message, setMessage] = React.useState({
		id: 0,
		pixel_map: ''
	});
	const [loaded, setLoaded] = React.useState(false);
	const [messageList, setMessageList] = React.useState([]);
	const [token, setToken] = React.useState(0);
	const [myConfig, setMyConfig] = React.useState({
		messages: [],
		pixel_maps : []
	});
	const [cid, setCid] = React.useState(0);
	
	const handleSelect = (num) => {
		if(myConfig){
			console.log('we have a config');
			console.log(myConfig);
			if(myConfig.pixel_maps){
				console.log('we have maps');
				console.log(myConfig.pixel_maps);
				if(myConfig.pixel_maps[displays[num]]){
					console.log('we found a map');
					setMessage(myConfig.pixel_maps[displays[num]]);
					console.log(message);
				} else {
					console.log('couldn not find map');
				}
			} else {
				console.log('pixel maps are not defined');
			}	
		} else {
			console.log('we have no config');
		}
		setSelected(num);
	} 
	
	const handleApply = (newmap) => {
		//get the new pixel map and save changes
		var msg = Object.assign({}, message);
		msg.pixel_map = compileMap(newmap);
		handleSend({
			vso: 'message_standard',
			subaction: 'save',
			message : msg
		}, (data) => {
			let newConfig = Object.assign({}, myConfig);
			let newDisplays = Object.assign([], displays);
			//console.log(data);
			newConfig.pixel_maps[data.message.id] = data.message;
			newConfig.messages[selected] = data.message.id;
			newConfig['message'+selected] = data.message.id;
			newDisplays[selected] = data.message.id;
			setMyConfig(newConfig);
			setDisplays(newDisplays);
			setMessage(data.message);
			if(onChange){
				onChange(newConfig);
			}
			
		})
	}

	const get_messages = () => {
		if(sign.id){
			setLoaded(true);
			handleSend({
				vso: 'messages_standard'
			}, (data) => {
				setMessageList(data.messages)
			})
		}
	}
	
	React.useEffect(() => {
		//if(config){
		//	console.log('we have a config (useEffect)');
			if(
				//inherited config ID is null
				cid === 0 || 
				cid === undefined || 
				cid === null || 
				cid === "0" || 
				//inherited daysetting has changed
				cid !== config.id 
				//updated from server
				|| loadedToken !== token
			) {
				console.log('config has changed');
				//refresh from new config loaded
				if(config.messages){
					console.log('we have messages (useEffect)');
					console.log(config.messages);
					setDisplays(config.messages);
					//setMyConfig(config);
				}
				if(config.pixel_maps){
					if(config.pixel_maps[config.messages[selected]]){
						console.log('setting message (useEffect)');
						setMessage(config.pixel_maps[config.messages[selected]]);
					}
				}
				setMyConfig(config);
				setCid(config.id);
				setToken(loadedToken);
			} else {
				console.log('config has not changed');
			}
			console.log(config);
			console.log(displays);
		if(!loaded){
			//refresh display buttons on load (so they're not broken images)
			//setTimeout(() => setLoaded(true), 150);
			get_messages();
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	const dv = displayVariant(sign);

	const compileSettings = (map) => {
		return Object.assign({}, dv.size, {
			map : dv.extract(map)
		});
	}

	const compileMap = (map) => {
		return dv.compile(map);
	}

	const renderDisplay = (msg) => {
		var ds = compileSettings(myConfig.pixel_maps[msg].pixel_map);
		return (
			<Display scale={2} splitVertical={ds.split} width={ds.width} height={ds.height} pixel_map={ds.map} />
		)
	}
	
	const renderCanvas = () => {
		var ds = compileSettings(message.pixel_map);
		return (
			<Canvas id={message.id} pixel_map={ds.map} height={ds.height} width={ds.width} fontSize={2} splitVertical={ds.split} onSubmit={handleApply} />
		);
	}

	const renderMap = (message) => {
		return dv.extract(message.pixel_map);
	}

	const handleSaveMessageProperties = (message) => {
		//save message properties
		
		console.log('updated properties', message);
		handleSend({
			vso: 'message_standard',
			subaction: 'save',
			message : message
		}, (data) => {
			//copy message list object
			let newmsglist = Object.assign([], messageList);
			//find index of message
			let index = newmsglist.findIndex(n => n.id === message.id);
			//replace in list
			newmsglist.splice(index, 1, data.message);
			//update list
			setMessageList(newmsglist);
			
		})
		
		console.log('saved message', message);
	}

	const handleDelete = (message) => {
		handleSend({
			vso: 'message_standard',
			subaction: 'delete',
			message : message
		}, (data) => {
			let msgList = Object.assign([], messageList);
			//remove deleted message from list
			msgList.splice(msgList.findIndex(msg => msg.id === message.id), 1);
			//update message list
			setMessageList(msgList);
		})
		console.log('deleted message', message);
	}

	const handleSelectMessage = (message) => {
		//copy displays 
		let newDisplays = Object.assign([], displays);
		//set message for current display
		newDisplays[selected] = message.id;
		//copy config
		let newConfig = Object.assign({}, myConfig);
		//add pixel map to config's list
		newConfig.pixel_maps[message.id] = message;
		//update config's messages
		newConfig.messages[selected] = message.id;
		//update the flat message
		newConfig['message'+selected] = message.id;
		//update config state
		setMyConfig(newConfig);
		//update displays
		setDisplays(newDisplays);
		//update current message
		setMessage(message);
		if(onChange){
			onChange(newConfig);
		}
		console.log('selected message', message);
	}
	

	

  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<div className={classes.root}>
			<Grid container>
				<div className={classes.displayList}>
				<ButtonGroup orientation="vertical">
					{displays.map((msg, i) => (
						<Button
							key={i}
							variant={selected === i ? "contained" : "outlined"}
							startIcon={renderDisplay(msg)}
							onClick={(e) => {handleSelect(i)}}
						>{i+1}</Button>
					))}
				</ButtonGroup>
				</div>
    			{renderCanvas()}
			</Grid>
			<Selector width={dv.size.width} height={dv.size.height} splitVertical={dv.size.split}
				items={messageList}
				onSelect={handleSelectMessage}
				onDelete={handleDelete}
				isAdmin={() => true}
				render={renderMap}
				onSave={handleSaveMessageProperties}
				scale={2}
			/>
    	</div>
  );
}
